import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, Form, Input, Modal, Table } from "antd";
import { getColumns } from "./modules/getColumns";
import { useUsers } from "./modules/useUsers";

function UsersTemplate() {
  const {
    users,
    isModalOpen,
    isEditing,
    showPassword,
    form,
    handleCreate,
    handleEdit,
    handleDelete,
    handleToggleAdmin,
    handleModalOk,
    handleModalCancel,
    togglePasswordVisibility,
  } = useUsers();

  const columns = getColumns({ handleToggleAdmin, handleEdit, handleDelete });

  return (
    <div className="row ms-5 mb-3">
      <div className="col-md-10">
        <h1>Users Management</h1>
        <Button
          type="primary"
          onClick={handleCreate}
          style={{ marginBottom: "16px" }}
        >
          Add User
        </Button>
        <Table dataSource={users} columns={columns} rowKey="_id" />

        {/* Modal for Add/Edit User */}
        <Modal
          title={isEditing ? "Edit User" : "Add User"}
          visible={isModalOpen}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
        >
          <Form form={form} layout="vertical">
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Please enter the name" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: "Please enter the email" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: !isEditing, message: "Please enter the password" },
              ]}
            >
              <Input.Password
                type={showPassword ? "text" : "password"}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                addonAfter={
                  <Button
                    type="text"
                    icon={
                      showPassword ? <EyeInvisibleOutlined /> : <EyeTwoTone />
                    }
                    onClick={togglePasswordVisibility}
                  />
                }
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default UsersTemplate;
